import { isPlatformServer } from '@angular/common';
import { HttpHandlerFn, HttpRequest, HttpEvent } from '@angular/common/http';
import {PLATFORM_ID, inject, InjectionToken, REQUEST, REQUEST_CONTEXT} from '@angular/core';
import { Observable } from 'rxjs';

export interface SSRRequestContext {
  SSR_CLIENT_IP: string | null;
  SSR_CLIENT_UA: string | null;
}

export function ssrForwardInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {

  const platformId = inject(PLATFORM_ID);

  // Only during SSR
  if (isPlatformServer(platformId)) {

    const requestContext = inject<SSRRequestContext>(REQUEST_CONTEXT, { optional: true });
    if (requestContext) {
      // Clone the request and inject the end-user's true identity headers
      const forwardedReq = request.clone({
        headers: request.headers
          .set('X-SSR-Client-IP', requestContext.SSR_CLIENT_IP ?? '')
          .set('X-SSR-Client-UA', requestContext.SSR_CLIENT_UA ?? '')
      });

      return next(forwardedReq);
    }
  }

  // Regular browser-side execution fallback
  return next(request);
}
